import {
  Directions,
  Divider,
  Drawer,
  Pecten,
  Positions,
  Sizes,
} from '@sede-enterprise/shell-ds-react-framework';
import {
  HeaderSubText,
  HeaderText,
  HeaderTextWrapper,
} from 'components/NavBar/NavBar.styled';
import ProfileMenu from 'components/NavBar/ProfileMenu';
import { useStore } from 'store';

export const MobileProfileDrawer = () => {
  const [setMobileProfileClosed] = useStore((state) => [
    state.setMobileProfileClosed,
  ]);

  return (
    <Drawer
      data-testid="mobile-profile-drawer"
      header={{ title: 'Profile' }}
      size={Sizes.Small}
      open
      placement={Positions.Bottom}
      onClose={setMobileProfileClosed}
      mask
      elevation={true}
      padding={true}
      style={{ zIndex: 40 }}
    >
      <>
        <ProfileMenu />
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            paddingLeft: '16px',
            marginBottom: '4px',
          }}
        >
          <Pecten size={Sizes.Medium} />

          <Divider
            style={{ margin: '0 8px' }}
            direction={Directions.Vertical}
            prominence={'subtle'}
          />
          <HeaderTextWrapper>
            <HeaderSubText>Shell Energy</HeaderSubText>
            <HeaderText>Battery Management Hub</HeaderText>
          </HeaderTextWrapper>
        </div>
      </>
    </Drawer>
  );
};
